const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/sagas/nativeAppAuthSaga.ts';
import { showSnackbar } from '@cistec/common_web/actions/uiActions';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { SagaIterator } from 'redux-saga';
import { delay, put, race, select, take } from 'redux-saga/effects';
import { replace } from 'redux-first-history';
import { appAuthTimeDiffCalcWithThreshold, appAuthTimeDiffError } from 'App/utils/generalUtils';
import { isLoggedIn } from 'App/store/login';
import { PATH_DASHBOARD } from 'App/defs/router';
import {
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_FAILURE,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_REFRESH,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_REFRESH_SUCCESS,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SES_ERROR,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS_FROM_KEYSTORE,
} from 'App/actions/patAppNative';

const Log = Logger('nativeAppAuthSaga');

const oneDayInMillis = 86400000;

export function* nativeAppAuthSaga(): SagaIterator {
    let timeout = oneDayInMillis;
    while (true) {
        try {
            const { action } = yield race({
                action: take([
                    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_FAILURE,
                    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SES_ERROR,
                    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS,
                    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS_FROM_KEYSTORE,
                    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_REFRESH_SUCCESS,
                ]),
                timeout: delay(timeout),
            });

            if (action) {
                if (
                    action.type === ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_FAILURE ||
                    action.type === ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SES_ERROR
                ) {
                    if (
                        process.env.NODE_ENV !== 'production' &&
                        action.type === ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SES_ERROR
                    ) {
                        if (action.payload === undefined) {
                            yield put(showSnackbar('Fehler beim Anmelden (kommt nur im DEV-Mode):1:' + action.type));
                        } else {
                            yield put(
                                showSnackbar(
                                    'Fehler beim Anmelden (kommt nur im DEV-Mode):2:' +
                                        action.type +
                                        '::' +
                                        JSON.stringify(action.payload)
                                )
                            );
                        }
                    }
                    // we dont need to send anything to user in case login did fail
                } else if (action.type === ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS) {
                    yield put(replace(PATH_DASHBOARD));

                    // accessTokenExpirationDate = 2022-07-05T12:13:31Z
                    timeout = calcDiff(action.payload.accessTokenExpirationDate);
                } else if (action.type === ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS_FROM_KEYSTORE) {
                    // accessTokenExpirationDate = 2022-07-05T12:13:31Z
                    timeout = calcDiff(action.payload.accessTokenExpirationDate);
                } else if (action.type === ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_REFRESH_SUCCESS) {
                    timeout = calcDiff(action.payload.accessTokenExpirationDate);
                }
            } else {
                // this is the timeout case
                const isLoggedInState = yield select(isLoggedIn);
                if (isLoggedInState) {
                    yield put({ type: ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_REFRESH });
                } else {
                    // wait
                    timeout = oneDayInMillis;
                }
            }
        } catch (e) {
            // we dont bother user (with showUncaughtErrorDialog) he just needs to relogin
            yield put(replace('/app/startPage'));
            Log.error(`Exception! ${e.message}`, e);
        }
    }
}

const calcDiff = (expDateTime: string) => {
    const diff = appAuthTimeDiffCalcWithThreshold(expDateTime);
    if (appAuthTimeDiffError(expDateTime)) {
        throw Error('nativeAppAuthSaga:: time diff to request a new refreshToken is too small < 2000ms:' + diff);
    }
    return diff;
};
